export const shadowTheme = {
  black: '#000',
} as const;
